import { dataBookOpen } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBookOpen = /*#__PURE__*/createIcon(dataBookOpen)
export default IconBookOpen
